<template>
  <div class="btn-group" role="group">
    <div class="multi-select">
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <provide-state-triggered-by-slot-props v-slot="{ turnOn, turnOff, toggle, isOn }">
        <BasePopper v-click-outside="turnOff" :display="isOn">
          <button
            :disabled="disabled"
            class="dropdown-toggle btn btn-sm btn-default"
            aria-haspopup="true"
            @click="toggle"
          >
            <slot>
              {{ $t(options[selected]) }}
            </slot>
            <span class="caret m-l-5" />
          </button>
          <template #popper>
            <ul v-if="!disabled" class="base-dropdown-menu">
              <slot :popper-flipper="isOn" name="custom-options" />
              <li
                v-for="(option, key) in options"
                :key="key"
                class="pointer"
                @click="fZip(selectOption(key), closeOnSelection ? turnOff() : turnOn())"
              >
                <a :class="{ hide: !isOn }">
                  {{ $t(option) }}
                </a>
              </li>
            </ul>
          </template>
        </BasePopper>
      </provide-state-triggered-by-slot-props>
    </div>
  </div>
</template>

<script>
import BasePopper from '@/components/BasePopper.vue'
import FunctionZipMixin from '@/mixins/MethodFZipMixin'

export default {
  name: 'BaseSingleSelect',
  components: {
    BasePopper,
  },
  mixins: [FunctionZipMixin],
  props: {
    // Just some object of type { key: value } where it takes the key as the key
    // and displays the value as an option to select
    options: {
      type: Object,
      required: true,
    },
    // Simply the already selected option
    // The value should match one of the keys in the previous object
    selectedIn: {
      type: [Number, String],
      required: true,
    },
    closeOnSelection: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:selectedIn', 'change'],
  data() {
    return {
      selected: '',
    }
  },
  watch: {
    selectedIn(change) {
      this.selected = change
    },
  },

  created() {
    this.selected = this.selectedIn
  },
  methods: {
    selectOption(key) {
      this.selected = key
      this.$emit('update:selectedIn', this.selected)
      this.$emit('change', this.selected)
    },
  },
}
</script>

<style scoped lang="scss">
label {
  padding: 10px !important;
}
</style>
